import { useState, useEffect } from "react";
import { getUserTypes } from "../../network/lib/masterData.js";
import { userObject, create } from "../../network/lib/user.js";
import { showHideLoader } from "../utils/helper.js";

function CreateLogin({ user }) {
  const [loginTypes, setLoginTypes] = useState();
  const [selectedType, setselectedType] = useState("0");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  useEffect(() => {
    !loginTypes && populateLoginTypes();
  }, []);

  function populateLoginTypes() {
    getUserTypes().then((res) => {
      res.status == 200 && setLoginTypes(res.data);
    });
  }

  const setToDefault = () => {
    setselectedType("0");
    setUserName("");
    setPassword("");
    setConfirmNewPassword("");
  };

  const handleCancel = (e) => {
    e.preventDefault();

    let message = document.getElementById("message");
    message.innerHTML = "";

    setToDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let message = document.getElementById("message");
    message.innerHTML = "";

    if (selectedType == 0) {
      message.innerHTML = "Please select Login Type";
    } else if (!userName) {
      message.innerHTML = "Please enter UserName";
    } else if (!password) {
      message.innerHTML = "Please enter Password";
    } else if (!confirmNewPassword) {
      message.innerHTML = "Please enter Confirm Password";
    } else if (password != confirmNewPassword) {
      message.innerHTML = "Password's are not matching";
    } else {
      showHideLoader(true);

      userObject.roleId = selectedType;
      userObject.userName = userName;
      userObject.password = password;
      userObject.activityDoneBy = user.userName;

      create(userObject).then((res) => {
        if (res.status == 200 && res.data) {
          message.classList.replace("alert", "success");
          message.innerHTML = "User Created successfully!!!";
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
        setToDefault();
        showHideLoader();
      });
    }
  };

  const types = loginTypes && (
    <select
      onChange={(e) => setselectedType(e.target.value)}
      value={selectedType}
      style={{ width: "188px" }}
    >
      <option value="0">Select</option>
      {loginTypes.map((x, index) => (
        <option key={index} value={x.id}>
          {x.name}
        </option>
      ))}
    </select>
  );

  const contents = (
    <>
      <table style={{ width: "45%" }}>
        <tbody>
          <tr>
            <th align="center" colSpan="2">
              Create Login
            </th>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Login Type</span>
            </td>
            <td>{types}</td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">UserName</span>
            </td>
            <td>
              <input
                name="userName"
                type="text"
                value={userName}
                id="userName"
                onChange={(e) => setUserName(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Password</span>
            </td>
            <td>
              <input
                name="password"
                type="password"
                value={password}
                id="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Confirm Password</span>
            </td>
            <td>
              <input
                name="confirmNewPassword"
                type="password"
                value={confirmNewPassword}
                id="confirmNewPassword"
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
              <div
                data-lastpass-icon-root=""
                style={{
                  position: "relative !important",
                  height: "0px !important",
                  width: "0px !important",
                  float: "left !important",
                }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td style={{ textAlign: "right", paddingRight: "53px" }}>
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );

  return contents;
}

export default CreateLogin;
